import { FC } from 'react';
import AppFormControl from './AppFormControl';

import PhoneNumberInput, {
  PhoneNumberInputProps,
} from 'presentation/components/shared/fields/PhoneNumberInput/PhoneNumberInput';

interface Props extends Omit<PhoneNumberInputProps, 'name'>, FormFieldProps {}

const FormPhoneNumberInput: FC<Props> = ({ label, helperText, ...props }) => {
  return (
    <AppFormControl name={props.name} label={label} helperText={helperText}>
      <PhoneNumberInput {...props} />
    </AppFormControl>
  );
};

export default FormPhoneNumberInput;
